import { CheckCircle2 } from 'lucide-react';

export function RecoverySuccess({ onContinue }) {
  return (
    <div className="absolute inset-0 bg-black/20 flex items-end z-50 animate-in fade-in duration-300">
      <div className="w-full max-w-xl mx-auto bg-white rounded-t-[40px] p-8 md:p-10 flex flex-col items-center animate-in slide-in-from-bottom-full duration-500 shadow-2xl">
        <div className="w-12 h-1 bg-slate-200 rounded-full mb-8" />
        
        <div className="relative mb-6">
          <div className="absolute inset-0 bg-[#0A4730]/10 rounded-full scale-150 animate-pulse" />
          <CheckCircle2 size={72} className="text-[#0A4730] relative z-10" strokeWidth={1.5} />
        </div>

        <h2 className="text-2xl text-[#0A4730] font-serif font-semibold tracking-tight mb-2 text-center">
          Account Recovered
        </h2>
        
        <p className="text-slate-500 text-sm leading-relaxed text-center mb-8 max-w-sm">
          You have successfully recovered your account! You're ready to proceed.
        </p>

        {onContinue && (
          <button
            onClick={onContinue}
            className="w-full h-14 rounded-2xl bg-[#0A4730] text-white font-bold tracking-wide hover:bg-[#0A4730]/90 transition-all shadow-lg active:scale-[0.98]"
          >
            Continue
          </button>
        )}
      </div>
    </div>
  );
}